import React from 'react';
import './App.css';
import whatsappIcon from './assets/whatsapp-icon.png'; // Иконка WhatsApp
import iranFlag from './assets/iran-flag.png'; // Флаг Ирана
import uaeFlag from './assets/uae-flag.png'; // Флаг ОАЭ

function App() {
  return (
    <div className="App">
      <header className="App-header">
        {/* Сообщение на английском */}
        <h1>Website under development</h1>
        {/* Сообщение на фарси */}
        <h2>وب سایت در حال توسعه است</h2>

        {/* Контактная информация */}
        <div className="contact-info">
          <h3 className="contact-title">For inquiries, please contact:</h3>
          <h3 className="contact-title">برای سوالات لطفا تماس بگیرید:</h3>
          
          {/* Email */}
          <div className="contact-item email-item">
            <div className="contact-icon-wrapper">
              <svg className="contact-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="6" width="16" height="12" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M4 8L12 13L20 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <a href="mailto:info1@vppc-ir.com" className="contact-link email-link">
              info1@vppc-ir.com
            </a>
          </div>

          {/* WhatsApp для Ирана */}
          <div className="contact-item whatsapp-item">
            <div className="contact-icons-group">
              <img
                src={iranFlag}
                alt="Iran Flag"
                className="flag-icon"
              />
              <img
                src={whatsappIcon}
                alt="WhatsApp"
                className="whatsapp-icon"
              />
            </div>
            <a
              href="https://wa.me/989960619929"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link whatsapp-link"
            >
              <span className="contact-label">WhatsApp Iran:</span>
              <span className="contact-value">+98 996 061 9929</span>
            </a>
          </div>

          {/* WhatsApp для ОАЭ */}
          <div className="contact-item whatsapp-item">
            <div className="contact-icons-group">
              <img
                src={uaeFlag}
                alt="UAE Flag"
                className="flag-icon"
              />
              <img
                src={whatsappIcon}
                alt="WhatsApp"
                className="whatsapp-icon"
              />
            </div>
            <a
              href="https://wa.me/971557964799"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link whatsapp-link"
            >
              <span className="contact-label">WhatsApp UAE:</span>
              <span className="contact-value">+971 55 796 4799</span>
            </a>
          </div>
        </div>
      </header>
    </div>
  );
}

export default App;